module.exports = __webpack_public_path__ + "src/assets/images/template-icon7.png";